import { validateNotEmptyString } from '@vy/utils';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useHubspotAuthRedirect() {
  return useMutation(async () => {
    const api = getPrivateApi();

    const { redirectUrl } = await api.hubspotAuthConnect();

    validateNotEmptyString(redirectUrl, 'redirectUrl');

    window.location.href = redirectUrl;
  });
}
